function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
const base = '/account/config';
class AdvancedSettingsHTTPClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getAdvancedSettingsConfig", ()=>this.get(base)), _define_property(this, "updateAdvancedSettingsConfig", (data)=>this.put(base, data));
    }
}
export const AdvancedSettingsAPI = new AdvancedSettingsHTTPClient();
